export interface CurvePoint {
	age: number;
	fp: number;
}

export interface CurveSeriesData {
	historyData: [number, number][];
	projectionData: [number, number][];
}

/**
 * Split a group survival curve into "history" (up to and including the asset's current age)
 * and "projection" (current age onwards) series for charting.
 *
 * The point at `currentAge` is intentionally included in BOTH series so the solid history
 * line and the dashed projection line join seamlessly at the current position.
 */
export const splitCurveAtAge = (curveData: CurvePoint[], currentAge: number): CurveSeriesData => ({
	historyData: curveData.filter(d => d.age <= currentAge).map(d => [d.age, d.fp] as [number, number]),
	projectionData: curveData.filter(d => d.age >= currentAge).map(d => [d.age, d.fp] as [number, number]),
});
